(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip-selector-1x2/assets/javascripts/betslips/u-system.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip-selector-1x2/assets/javascripts/betslips/u-system.js');
"use strict";

var _svs$core$config$data, _svs$core$config$data2;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector;
const format = svs.utils.format;
const clx = svs.components.lbUtils.clx;
const _svs$components$tipse = svs.components.tipsen.betslipComponents,
  Betslip = _svs$components$tipse.Betslip,
  useBetslipContext = _svs$components$tipse.useBetslipContext;
const isSelfService = (_svs$core$config$data = (_svs$core$config$data2 = svs.core.config.data.svsconfig) === null || _svs$core$config$data2 === void 0 ? void 0 : _svs$core$config$data2.isSelfService) !== null && _svs$core$config$data !== void 0 ? _svs$core$config$data : false;
const getSystemLabelFromNumber = svs.components.sport.systems.getSystemLabelFromNumber;
const _svs$components$tipse2 = svs.components.tipsen.engine.selectors.couponSelectors,
  selectUSignsCount = _svs$components$tipse2.selectUSignsCount,
  selectRequiredUSigns = _svs$components$tipse2.selectRequiredUSigns,
  selectUSystem = _svs$components$tipse2.selectUSystem;
const USystem = () => {
  const context = useBetslipContext();
  const couponId = context.couponId,
    isCouponValid = context.isCouponValid,
    isMedium = context.isMedium,
    price = context.price;
  const isPlayer = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const isAnonymous = svs.core.userSession.isAnonymous();
  const shouldDisplayBalance = isCouponValid && (isAnonymous || isPlayer) && !isSelfService && isMedium;
  const systemNum = useSelector(state => selectUSystem(state, couponId));
  const uSigns = useSelector(state => selectUSignsCount(state, couponId));
  const requiredUSigns = useSelector(state => selectRequiredUSigns(state, couponId));
  const blockName = 'pg_tipsen_betslip__content';
  const classNames = clx(blockName, {
    ["".concat(blockName, "--valid_coupon")]: isCouponValid,
    ["".concat(blockName, "--no_progress_bar")]: !isCouponValid
  });
  const systemLabel = getSystemLabelFromNumber(systemNum);
  return React.createElement("div", {
    className: classNames
  }, React.createElement("span", {
    className: "pg_tipsen_betslip_system_info"
  }, React.createElement(Betslip.HedgesView, null), React.createElement("div", {
    "aria-label": "Valt system: ".concat(systemLabel),
    className: "pg_tipsen_betslip_system"
  }, systemLabel, ' ', React.createElement("span", {
    "aria-label": "".concat(uSigns, " av ").concat(requiredUSigns, " u-tecken valda"),
    "aria-live": "polite",
    className: "pg_tipsen_betslip_system__u_signs"
  }, uSigns), ' ', "(", requiredUSigns, ")")), shouldDisplayBalance && React.createElement("span", {
    className: "pg_tipsen_betslip_balance"
  }, React.createElement(Betslip.BalanceView, null)), !isCouponValid && React.createElement("span", {
    className: "pg_tipsen_betslip_system_instructions"
  }, "Du har fyllt i f\xF6r f\xE5 eller f\xF6r m\xE5nga alternativ"), React.createElement("div", {
    className: "pg_tipsen_betslip_price"
  }, format.Currency(price), "\xA0KR"), isCouponValid && React.createElement("span", {
    className: "pg_tipsen_betslip_pay_button"
  }, React.createElement(Betslip.PayButton, null)));
};
setGlobal('svs.components.tipsen.betslipSelector1x2.betslips.USystem', USystem);

 })(window);